// extracted by mini-css-extract-plugin
export default {"container":"FuwTabs_container__0BhtU","button":"FuwTabs_button__vz-Mq","active":"FuwTabs_active__vJIW8","text":"FuwTabs_text__3zNeL"};